import { CSS, StyleProps } from "../styles"

export const icon = (props: StyleProps): CSS => ({
  color: props.theme.palette.coal.light,
  cursor: `pointer`,
  fontSize: props.theme.fontSize.large,
  marginLeft: props.theme.spacing(2),
})
